/**
 * Created by andrey on 19.02.2026
 *
 * https://developers.facebook.com/docs/games/instant-games/sdk/fbinstant8.0/
 * The game can store up to 1MB of data for each unique player.
 *
 * No need save full data - setDataAsync merge keys with existing data.
 *
 * An object containing a set of key-value pairs that should be persisted to cloud storage.
 * The object must contain only serializable values - any non-serializable values will cause the entire modification to be rejected.
 */

class InstantTransportAdapter {
    constructor() {
        this.bucketData = new BucketsTransportData(32);
    }

    saveData(data, options, onSuccess, onFailure) {
        let bucketsData = {};

        if (options.syncout) {
            bucketsData = this.bucketData.clearData();
        }

        bucketsData = Object.assign(bucketsData, this.bucketData.addData(data));

        FBInstant.player.setDataAsync(bucketsData)
            .then(onSuccess)
            .catch(onFailure);
    }

    loadSession(onSuccess, onFailure) {
        const sessionBucketKey = this.bucketData.getSessionBucketKey();

        FBInstant.player.getDataAsync([sessionBucketKey])
            .then((data) => {
                data = this.bucketData.parseResponse(data);
                onSuccess(data && data.session);
            })
            .catch(onFailure);
    }

    loadData(onSuccess, onFailure) {
        const bucketKeys = this.bucketData.getAllBucketKeys();

        FBInstant.player.getDataAsync(bucketKeys)
            .then((data) => {
                this.bucketData.setData({ ...data });

                data = this.bucketData.parseResponse(data);
                onSuccess(data);
            })
            .catch(onFailure);
    }
}
